import AddDoctorForm from 'components/form/admin/doctor/AddDoctorForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class AddDoctor extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Doctor</h4>
                                <AddDoctorForm />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
